module.exports = __webpack_public_path__ + "26354d8e8f4a60f6f4274f04924d6ec5.MP3";